export default {
    approvals: {
        title: "Jóváhagyás",
        error: "Hiba történt"
    },
    delegates: {
        title: "küldöttek",
        error: "Hiba történt",
        noDelegates: "Nincsenek elemek",
        delegateDelete: "A meghatalmazott törölve",
        confirm: {
            delete: "Törli a meghatalmazottat?"
        },
        delegates: {
            email: "Email",
            startDate: "Kezdő dátum",
            endDate: "Befejezési dátum",
        },
        buttons: {
            add: {
                text: "Meghatalmazott hozzáadása"
            }
        }
    },
    employees: {
        title: "Alkalmazottaim",
        error: "Hiba történt",
        empty: "Nem található alkalmazott",
        users: {
            name: "Név",
            email: "Email"
        },
        model: {
            search: {
                placeholder: "Keresés",
            }
        },
        cta: {
            orders: "Megbízások betöltése",
            download: "Megrendelések letöltése",
            search: "Keresés"
        }
    }
}